import { formatZipPostal } from 'shared/utils/formatting';

class Address {
	constructor(address = {}) {
		this.address1 = address.address1 || '';
		this.address2 = address.address2 || '';
		this.city = address.city || '';
		this.state = address.state || '';
		this.zipCode = formatZipPostal(address.zipCode) || '';
	}
}

export default Address;
